<!--
@component
Footer.Root

A flexible footer root component that supports dynamic styling and content organization.

@prop colorVariant - The color variant of the footer.
@prop css - Custom CSS styles to be applied to the footer.
@prop ariaLabel - Optional ARIA label for the footer.

@example
<Footer.Root colorVariant="primary">
  ...components
</Footer.Root>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { dynamicColorString } from '@agapi/ui/panda/utils';
  import { footerStyles } from '../footer.styles';
  import type { FooterRootProps } from '../footer.types';

  /** Props for the Footer.Root component. */
  const { children, css: cssProp = {}, colorVariant = "default", ariaLabel }: FooterRootProps = $props();

  /** Classes for the footer. */
  const classes = footerStyles.raw({});
</script>

<footer
  class={css(classes.root, cssProp)}
  style={dynamicColorString(colorVariant)}
  aria-label={ariaLabel}
>
  {@render children?.()}
</footer>